/**
 * Jookbox Orchestrator Logo
 * 
 * A modern logo representing unified music streaming
 * - Musical notes converging into one
 * - Represents orchestration of multiple services
 */

import React from 'react';

function Logo({ size = 40, showText = true, className = '' }) {
  return (
    <div className={`jookbox-logo ${className}`} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 100 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background circle with gradient */}
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#667eea" />
            <stop offset="50%" stopColor="#764ba2" />
            <stop offset="100%" stopColor="#f093fb" />
          </linearGradient>
          <linearGradient id="noteGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="100%" stopColor="#e0e0ff" />
          </linearGradient>
          <filter id="glow">
            <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
        
        {/* Main circle */}
        <circle cx="50" cy="50" r="46" fill="url(#logoGradient)" />
        <circle cx="50" cy="50" r="42" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
        
        {/* Orbiting rings representing multiple services */}
        <ellipse cx="50" cy="50" rx="35" ry="12" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" transform="rotate(-30 50 50)" />
        <ellipse cx="50" cy="50" rx="35" ry="12" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" transform="rotate(30 50 50)" />
        <ellipse cx="50" cy="50" rx="35" ry="12" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" transform="rotate(90 50 50)" />
        
        {/* Central music note */}
        <g filter="url(#glow)">
          {/* Note head */}
          <ellipse cx="42" cy="62" rx="10" ry="8" fill="url(#noteGradient)" transform="rotate(-20 42 62)" />
          {/* Note stem */}
          <rect x="49" y="28" width="4" height="36" fill="url(#noteGradient)" rx="2" />
          {/* Note flag */}
          <path 
            d="M53 28 Q68 35 58 48 Q65 40 53 38" 
            fill="url(#noteGradient)" 
          />
        </g>
        
        {/* Small service dots */}
        <circle cx="20" cy="50" r="4" fill="#ff0000" opacity="0.9" /> {/* YouTube red */}
        <circle cx="50" cy="20" r="4" fill="#1db954" opacity="0.9" /> {/* Spotify green */}
        <circle cx="80" cy="50" r="4" fill="#fc3c44" opacity="0.9" /> {/* Apple red */}
        
      </svg>
      
      {showText && (
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
          <span style={{ 
            fontSize: size * 0.5, 
            fontWeight: 700, 
            color: '#fff',
            letterSpacing: '-0.02em'
          }}>
            Jookbox
          </span>
          <span style={{ 
            fontSize: size * 0.28, 
            fontWeight: 400, 
            color: 'rgba(255,255,255,0.7)',
            letterSpacing: '0.05em',
            textTransform: 'uppercase'
          }}>
            Orchestrator
          </span>
        </div>
      )}
    </div>
  );
}

export default Logo;

